import dropdown from '../core/dropdown'
import feed from '../core/feed'
import mobileMenu from './mobileMenu'
import reframe from './reframe'
import lightbox from './lightbox'
import parallax from './parallax'
import homepage from './homepage'

export default function init() {
  mobileMenu()
  reframe()
  lightbox()
  dropdown()
  feed()
  parallax()
  homepage()
}
